import React, { useEffect, useRef, useState } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Logo from '../imgs/logo.png'
import "../css/navbar.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarsStaggered, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import {useSiteSettings} from "../sanity/useSiteSettings";
import {urlFor} from "../sanity/imageUrl";


const CustomNavbar = () => {
    const {data} = useSiteSettings();
    const [expanded, setExpanded] = useState(false);
    const navbarRef = useRef(null);
    const nav = data?.navigation || {};
    const brandText = nav.brandText || "Biodanzaschule Freiburg";
    const navLogo = nav.logo ? urlFor(nav.logo) : Logo;
    const biodanzaItems = nav.biodanzaItems?.length ? nav.biodanzaItems : [
        {title: "Was ist Biodanza", href: "/biodanza"},
        {title: "Das Biozentrische System", href: "/das-biozentrische-system"},
    ];
    const ausbildungItems = nav.ausbildungItems?.length ? nav.ausbildungItems : [
        {title: "Ein Beruf mit Zukunft", href: "/ein-Beruf-mit-Zukunft"},
        {title: "Biodanzaschule Freiburg", href: "/biodanzaschuleFreibung"},
        {title: "Ausbildung", href: "/ausbildung"},
        {title: "Ausbildungskalender 2024-2027", href: "/ausbildungskalender"},
    ];
    const biodanzaLabel = nav.biodanzaLabel || "Biodanza";
    const eventsLabel = nav.eventsLabel || "Events";
    const ausbildungLabel = nav.ausbildungLabel || "Ausbildung";
    const ueberMichLabel = nav.ueberMichLabel || "Über mich";
    const linksLabel = nav.linksLabel || "Links";
    const kontaktLabel = nav.kontaktLabel || "Kontakt";

    useEffect(() => {
        document.body.style.paddingTop = '70px';
        return () => {
            document.body.style.paddingTop = '0px';
        };
    }, []);

    // Close burger menu when clicking outside of the navbar
    useEffect(() => {
        if (!expanded) return;

        const handlePointerDown = (e) => {
            const root = navbarRef.current;
            if (!root) return;
            if (root.contains(e.target)) return;
            setExpanded(false);
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('touchstart', handlePointerDown, { passive: true });

        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('touchstart', handlePointerDown);
        };
    }, [expanded]);

    return (
        <Navbar
            ref={navbarRef}
            fixed="top"
            collapseOnSelect
            expand="lg"
            className="navbar-root"
            expanded={expanded}
            onToggle={(nextExpanded) => setExpanded(nextExpanded)}
            onSelect={() => setExpanded(false)}
        >
            <Navbar.Brand className="navbar-brand-link" as={Link} to="/" onClick={() => setExpanded(false)}>
                <div className="d-flex flex-row align-items-center">
                    <img
                        src={navLogo}
                        height="40"
                        className="d-inline-block align-top navbar-logo"
                        alt="Logo"
                    />  <div className="logo-name"> {brandText}</div>
                </div>

            </Navbar.Brand>
            <Navbar.Toggle className="navbar-toggle-button" aria-controls="responsive-navbar-nav">
                <FontAwesomeIcon icon={faBarsStaggered} />
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                <Nav className="navbar-nav-right">
                    <NavDropdown
                        title={
                            <span>
                                {biodanzaLabel} <FontAwesomeIcon icon={faChevronDown} size="2xs" />
                            </span>
                        }
                        id="biodanza"
                    >
                        {biodanzaItems.map((item) => (
                            <NavDropdown.Item
                                key={item.href || item.title}
                                as={Link}
                                to={item.href}
                                onClick={() => setExpanded(false)}
                            >
                                {item.title}
                            </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                    <Nav.Link as={Link} to="/events" onClick={() => setExpanded(false)}>{eventsLabel}</Nav.Link>
                    <NavDropdown title={
                        <span>
                            {ausbildungLabel} <FontAwesomeIcon icon={faChevronDown} size="2xs" />
                        </span>
                    } id="ausbildung"
                    >
                        {ausbildungItems.map((item) => (
                            <NavDropdown.Item
                                key={item.href || item.title}
                                as={Link}
                                to={item.href}
                                onClick={() => setExpanded(false)}
                            >
                                {item.title}
                            </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                    <Nav.Link as={Link} to="/schulleitungBeateHoffman" onClick={() => setExpanded(false)}>{ueberMichLabel}</Nav.Link>
                    {/*<Nav.Link href="/events">Events</Nav.Link>*/}
                    <Nav.Link as={Link} to="/links" onClick={() => setExpanded(false)}>{linksLabel}</Nav.Link>
                    <Nav.Link as={Link} to="/kontakt" onClick={() => setExpanded(false)}>{kontaktLabel}</Nav.Link>

                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default CustomNavbar;




